import React, {useState} from "react";
import UserService from "../services/UserService";
import MaterialTable from "material-table";
import {tableIcons} from "../styles/TableIcons"
import Alert from '@material-ui/lab/Alert';
import {AddBox, Edit} from "@material-ui/icons";
import {useHistory} from "react-router-dom";
import {Container} from "@material-ui/core";
import {Path} from "../data/Constants";
import DateUtil from "../utils/DateUtil";
import {useTranslation} from "react-i18next";
import CompUtil from "../utils/CompUtil";

/**
 * The users listing and management view, lists all registered or created users
 * @author dame.gjorgjievski
 */
export default function UsersListView() {

    const history = useHistory()
    const {t} = useTranslation()
    const [errors, setErrors] = useState([])
    const columns = [
        {title: t("admin.default.fields.id"), field: "id", hidden: true},
        {title: t("admin.default.fields.name"), field: "name"},
        {title: t("admin.user.fields.surname"), field: "surname"},
        {title: t("admin.user.fields.email"), field: "email"},
        {title: t("admin.user.fields.phone"), field: "phone"},
        {title: t("admin.default.fields.type"), field: "roles"},
        {title: t("admin.default.fields.time-created"), field: "timeCreated", render: rowData => {
            rowData.timeCreated = DateUtil.toString(DateUtil.fromUtc(new Date(rowData.timeCreated)))
            return rowData.timeCreated.replace("T", " ")
        }}
    ]

    const handleRowDelete = (oldData, resolve) => {
        UserService.delete(oldData.id)
            .then(res => {
                resolve()
            })
            .catch(error => {
                setErrors(error.response.data.errors.length > 0 ? error.response.data.errors : [error.response.data.message])
                clearErrors()
                resolve()
            })
    }

    const clearErrors = () => {
        setTimeout(() => {
            setErrors([])
        }, 3000)
    }

    return (
        <Container maxWidth="lg" style={{width: '100%'}}>
            <MaterialTable
                title={t("admin.user.title")}
                columns={columns}
                icons={tableIcons}
                data={query => {
                    return new Promise((resolve, reject) => {
                        UserService.search(query)
                            .then(response => {
                                resolve({
                                    data: response.data.result,
                                    page: query.page,
                                    totalCount: response.data.totalCount,
                                })
                            })
                            .catch(error => {
                                console.log("got error", error, error.response)
                                setErrors([t("admin.default.errors.data-load")])
                            })
                    })
                }}
                actions={[
                    {
                        icon: () => <AddBox/>,
                        tooltip: t("admin.default.actions.add"),
                        position: "toolbar",
                        onClick: () => {
                            history.push(Path.ADMIN_USER_EDIT.replace(":id",0))
                        }
                    },
                    {
                        icon: () => <Edit/>,
                        tooltip: t("admin.default.actions.edit"),
                        onClick: (event, rowData) => {
                            history.push(Path.ADMIN_USER_EDIT.replace(":id", rowData.id))
                        }
                    }
                ]}
                editable={{
                    onRowDelete: (oldData) =>
                        new Promise((resolve) => {
                            handleRowDelete(oldData, resolve)
                        }),
                }}
                options={{
                    actionsColumnIndex: -1
                }}
                localization={CompUtil.localizeTable(t)}
            />
            <div style={{height: '30px'}}/>
            <div>
                {errors.length > 0 &&
                <Alert severity="error">
                    {errors.map((msg, i) => {
                        return <div key={i}>{msg}</div>
                    })}
                </Alert>
                }
            </div>
        </Container>
    )
}